import { useInterventionType } from "@/entities/referential/referential-intervention-types";

export const useTypesAndSubTypes = (included) => {
  const { types = [] } = useInterventionType();
  let interventionSubTypes = [];
  const includedTypes = included ? included.split(",") : undefined;
  const filteredTypes = includedTypes
    ? [...types].filter((type) => includedTypes.includes(String(type.id)))
    : types;
  filteredTypes.forEach(({ subtypes = [] }) => {
    if (subtypes && subtypes.length > 0)
      interventionSubTypes = interventionSubTypes.concat(subtypes);
  });

  return {
    typesFilter: {
      filterMode: "tree",
      filters: types.map(({ id, name }) => {
        return { text: name, value: id };
      }),
    },
    subTypesFilter: {
      filterMode: "tree",
      filters: interventionSubTypes.map(({ id, name }) => {
        return { text: name, value: id };
      }),
    },
  };
};
